/**
 * CROEV advertorial v1 (Luma) - page behaviour. Loaded once by croev-adv-v1-header.
 *
 * - Updated date: [data-adv-updated] = today minus data-days, en-US, recomputed in the browser.
 * - Sticky product bar: moved to <body> (never inside a transformed ancestor). It appears once the chapter marked
 *   [data-adv-sticky-start] is reached and then stays for the rest of the visit: no hiding over the offer section
 *   (there is no buy box on the page to compete with) and none on scrolling back up (Vilo, 2026-10-08).
 * - Animated loop: [data-adv-loop] pause/play swaps the animated WebP for its first-frame still. Reduced motion
 *   starts paused on the still.
 * - CTAs to the product page ([data-adv-cta="<position>"]: the quiet links, the sticky button, the offer button)
 *   carry the page's query string (UTMs, fbclid) onto the product URL, minus the preview-only keys, and send
 *   cta_click with the position.
 * - Analytics: the quiz module's payload shape and transports (window.dataLayer, Shopify.analytics.publish,
 *   optional sendBeacon, a DOM event), one session id per page view, events prefixed croev_adv_:
 *     view          page opened
 *     scroll_depth  each h2 reached (index, total, heading, percent of h2s)
 *     cta_click     a link to the product page (pos, label, href)
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-adv-root]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- analytics ---------- */
  function uid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* no-op */ }
    return 'adv-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  var A = {
    on: !!root && root.getAttribute('data-analytics') === 'on',
    page: (root && root.getAttribute('data-analytics-page')) || 'advertorial',
    hook: (root && root.getAttribute('data-analytics-webhook')) || '',
    sid: uid(),
    t0: Date.now(),
    track: function (name, data) {
      if (!A.on) return null;
      var p = { event: name, page_id: A.page, session_id: A.sid, ts: new Date().toISOString(), ms_since_start: Date.now() - A.t0, page_path: location.pathname };
      for (var k in data || {}) if (Object.prototype.hasOwnProperty.call(data, k)) p[k] = data[k];
      var full = 'croev_adv_' + name;
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: full, croev_adv: p }); } catch (e) { /* no-op */ }
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(full, p);
      } catch (e) { /* no-op */ }
      if (A.hook && navigator.sendBeacon) {
        try { navigator.sendBeacon(A.hook, new Blob([JSON.stringify(p)], { type: 'text/plain;charset=UTF-8' })); } catch (e) { /* no-op */ }
      }
      try { document.dispatchEvent(new CustomEvent('croev:adv:analytics', { detail: p })); } catch (e) { /* no-op */ }
      return p;
    }
  };
  window.CroevAdvAnalytics = A;
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    A.track('view', { referrer: document.referrer || null, viewport_w: window.innerWidth });

    /* ---------- the Updated date ---------- */
    document.querySelectorAll('[data-adv-updated]').forEach(function (t) {
      var d = new Date();
      d.setDate(d.getDate() - (parseInt(t.getAttribute('data-days'), 10) || 0));
      try { t.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); } catch (e) { /* keep the server date */ }
      var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      t.setAttribute('datetime', iso);
    });

    /* ---------- sticky product bar ---------- */
    var bar = document.querySelector('[data-adv-sticky]');
    var start = document.querySelector('[data-adv-sticky-start]');
    if (bar) {
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      var link = bar.querySelector('[data-adv-sticky-cta]');
      var shown = false, ticking = false;
      var setH = function () { document.documentElement.style.setProperty('--adv-sticky-h', bar.offsetHeight + 'px'); };
      /* one-way latch: off until the start chapter is reached, then on for good */
      var paint = function () {
        ticking = false;
        if (shown) return;
        var past = start ? start.getBoundingClientRect().top < window.innerHeight * 0.6 : window.scrollY > 900;
        if (!past) return;
        shown = true;
        bar.classList.add('is-on');
        bar.setAttribute('aria-hidden', 'false');
        if (link) link.tabIndex = 0;
        document.body.classList.add('adv-has-sticky');
        setH();
        window.removeEventListener('scroll', req);
      };
      var req = function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', function () { if (shown) setH(); else req(); }, { passive: true });
      paint();
    }

    /* ---------- in-page links to the offer: smooth unless reduced motion ---------- */
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (!a.closest('.croev-adv-v1')) return;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    /* ---------- animated loop with pause/play ---------- */
    document.querySelectorAll('[data-adv-loop]').forEach(function (fig) {
      var img = fig.querySelector('img');
      var btn = fig.querySelector('[data-adv-loop-btn]');
      var lab = fig.querySelector('[data-adv-loop-label]');
      if (!img || !btn) return;
      var anim = img.getAttribute('data-anim'), still = img.getAttribute('data-still');
      var set = function (playing) {
        fig.classList.toggle('is-paused', !playing);
        btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
        if (lab) lab.textContent = btn.getAttribute(playing ? 'data-pause' : 'data-play');
        if (still) img.src = playing ? anim + (anim.indexOf('?') > -1 ? '&' : '?') + 'r=' + Date.now() : still;
      };
      if (reduce && still) set(false); else fig.classList.remove('is-paused');
      btn.addEventListener('click', function () { set(fig.classList.contains('is-paused')); });
    });

    /* ---------- scroll depth: each h2 reached ---------- */
    var h2s = Array.prototype.slice.call(document.querySelectorAll('.croev-adv-v1 h2'));
    if ('IntersectionObserver' in window && h2s.length) {
      var seen = {};
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = h2s.indexOf(e.target);
          if (seen[i]) return;
          seen[i] = true;
          io.unobserve(e.target);
          A.track('scroll_depth', { h2_index: i + 1, h2_total: h2s.length, percent: Math.round((i + 1) / h2s.length * 100), heading: (e.target.textContent || '').trim().slice(0, 120) });
        });
      }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
      h2s.forEach(function (h) { io.observe(h); });
    }

    /* ---------- CTAs to the product page: carry the ad's query, record the click ---------- */
    var SKIP = { view: 1, preview_theme_id: 1, r: 1, _pos: 1, _sid: 1, _ss: 1, _psq: 1, _fid: 1 };
    document.querySelectorAll('[data-adv-cta]').forEach(function (a) {
      try {
        var here = new URLSearchParams(location.search);
        var u = new URL(a.getAttribute('href'), location.href);
        if (u.origin === location.origin) {
          here.forEach(function (v, k) { if (!SKIP[k] && !u.searchParams.has(k)) u.searchParams.set(k, v); });
          if (here.get('preview_theme_id')) u.searchParams.set('preview_theme_id', here.get('preview_theme_id'));
          a.setAttribute('href', u.pathname + u.search + u.hash);
        }
      } catch (e) { /* keep the plain link */ }
      a.addEventListener('click', function () {
        A.track('cta_click', { pos: a.getAttribute('data-adv-cta'), label: (a.textContent || '').trim().slice(0, 80), href: a.getAttribute('href') });
      });
    });
  });
})();
